export enum DATA_QA_ATTRIBUTES {
	EXTERNAL_URL = 'sidebar-urls-external-url-input',
	TYPE_REDIRECT = 'sidebar-urls-redirect-type-select',
	CANONICAL_URL = 'sidebar-urls-canonical-url-input',
	VIDEO_URLS = 'sidebar-urls-video-url-inputs',
	DESKTOP_URL = 'sidebar-urls-desktop-url-input',
	MOBILE_URL = 'sidebar-urls-mobile-url-input',
	AMP_URL = 'sidebar-urls-amp-url-input',
}
